
import React, { useEffect, useState } from "react";
import {
    Button, Row, Col, Card, Container, Input, Label, Form, FormFeedback, Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Spinner
} from "reactstrap";
import SimpleBar from "simplebar-react";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Toast Notifications
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// AWS Amplify Auth
import { signUp } from 'aws-amplify/auth';

import { Link, useNavigate } from "react-router-dom";

// Import images
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import country from "../../common/data/country";
import AuthSlider from '../AuthenticationInner/authCarousel';
import usFlag from "../../assets/images/flags/us.svg"

const Register = () => {
    const history = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formattedPhoneNumber, setFormattedPhoneNumber] = useState('');
    const [passwordShow, setPasswordShow] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [seletedCountry3, setseletedCountry3] = useState({
        id: 240,
        flagImg: usFlag,
        countryName: "United States of America",
        countryCode: "+1"
    });
    const [seletedCountry4, setseletedCountry4] = useState({
        id: 240,
        flagImg: usFlag,
        countryName: "United States of America",
        countryCode: "+1"
    });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpen2, setDropdownOpen2] = useState(false);
    const [dropdownOpen3, setDropdownOpen3] = useState(false);
    const [dropdownOpen4, setDropdownOpen4] = useState(false);
    const [dropdownOpen5, setDropdownOpen5] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const toggle2 = () => setDropdownOpen2((prevState) => !prevState);
    const toggle3 = () => setDropdownOpen3((prevState) => !prevState);
    const toggle4 = () => setDropdownOpen4((prevState) => !prevState);
    const toggle5 = () => setDropdownOpen5((prevState) => !prevState);

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            email: '',
            first_name: '',
            last_name: '',
            // username: '',
            password: '',
            confirm_password: '',
            phone_number: '',
            // country_code: countryCode,
            country: '', // Added country
            zip_code: '', // Added zip_code
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            first_name: Yup.string().required("Please Enter Your First Name"),
            last_name: Yup.string().required("Please Enter Your Last Name"),
            password: Yup.string().required("Please Enter Your Password"),
            confirm_password: Yup.string()
                .oneOf([Yup.ref("password"), null], "Confirm Password Doesn't Match")
                .required("Please Confirm Your Password"),
            phone_number: Yup.string().required("Please Enter Your Phone Number"),
            country: Yup.string().required("Please Enter Your Country"), // Added country validation
            zip_code: Yup.string().required("Please Enter Your Zip Code"), // Added zip_code validation
        }),
        onSubmit: async (values) => {
            setLoading(true);
            try {
                const formattedPhoneNumber = `${seletedCountry3?.countryCode}${validation.values.phone_number}`;

                // console.log(formattedPhoneNumber);

                const { password, email, phone_number, first_name, last_name, country, zip_code } = values;

                // console.log(phone_number);

                const phoneNumberRegex = /^\+?[1-9]\d{1,14}$/;
                if (!phoneNumberRegex.test(phone_number)) {
                    throw new Error('Invalid phone number format');
                }

                // Format phone number


                const { isSignUpComplete, userId, nextStep } = await signUp({
                    username: email,
                    password,
                    options: {
                        userAttributes: {
                            email,
                            phone_number: formattedPhoneNumber, // Ensure phone number is in E.164 format
                            'custom:firstname': first_name,
                            'custom:lastname': last_name,
                            'custom:country': country, // Added country to userAttributes
                            'custom:zipcode': zip_code, // Added zip_code to userAttributes
                        },
                        autoSignIn: true,
                    }
                });

                toast.success("Registration successful! Please check your email for the confirmation code.");
                setTimeout(() => history('/confirm-email', { state: { email: values.email } }), 3000);
            } catch (error) {
               
                toast.error(error.message);
            }
            setLoading(false);
        }
    });

    document.title = "Media Pulse | Sign Up";

    return (
        <React.Fragment>
            <div className="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
                <div className="bg-overlay"></div>
                <div className="auth-page-content overflow-hidden pt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <Card className="overflow-hidden m-0">
                                    <Row className="justify-content-center g-0">
                                        <AuthSlider />

                                        <div className="col-lg-6">
                                            <div className="p-lg-5 p-4">
                                                <div>
                                                    <h5 className="text-primary">Register Account</h5>
                                                    <p className="text-muted">Create a new account for you!</p>
                                                </div>

                                                <div className="mt-4">
                                                    <Form className="needs-validation" noValidate onSubmit={validation.handleSubmit}>
                                                        <div className="mb-3">
                                                            <Label htmlFor="useremail" className="form-label">Email <span className="text-danger">*</span></Label>
                                                            <Input
                                                                type="email"
                                                                className="form-control"
                                                                id="useremail"
                                                                placeholder="Enter email address"
                                                                name="email"
                                                                value={validation.values.email}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.email && validation.touched.email ? true : false}
                                                            />
                                                            {validation.errors.email && validation.touched.email ? (
                                                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                            ) : null}
                                                        </div>
                                                        <div className="mb-3">
                                                            <Label htmlFor="firstname" className="form-label">First Name <span className="text-danger">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="firstname"
                                                                placeholder="Enter First name"
                                                                name="first_name"
                                                                value={validation.values.first_name}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.first_name && validation.touched.first_name ? true : false}
                                                            />
                                                            {validation.errors.first_name && validation.touched.first_name ? (
                                                                <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                                                            ) : null}
                                                        </div>
                                                        <div className="mb-3">
                                                            <Label htmlFor="lastname" className="form-label">Last Name <span className="text-danger">*</span></Label>
                                                            <Input
                                                                type="text"
                                                                className="form-control"
                                                                id="lastname"
                                                                placeholder="Enter Last name"
                                                                name="last_name"
                                                                value={validation.values.last_name}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.last_name && validation.touched.last_name ? true : false}
                                                            />
                                                            {validation.errors.last_name && validation.touched.last_name ? (
                                                                <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <div className="mb-3">
                                                            <Label>Phone Number</Label>
                                                            <Dropdown className='input-group' isOpen={dropdownOpen4} toggle={toggle4}>
                                                                <DropdownToggle as="button" className="btn btn-light border arrow-none">
                                                                    <img src={seletedCountry3.flagImg} alt="country flag" className="options-flagimg" height="20" />
                                                                    <span className="countrylist-codeno text-muted">{seletedCountry3.countryCode}</span>
                                                                </DropdownToggle>
                                                                <input
                                                                    type="tel"
                                                                    className="form-control rounded-end flag-input"
                                                                    placeholder="Enter Phone Number"
                                                                    name="phone_number"
                                                                    value={validation.values.phone_number}
                                                                    onChange={(e) => {
                                                                        setFormattedPhoneNumber(`+${seletedCountry3?.code}${e.target.value}`);
                                                                        validation.setFieldValue('phone_number', e.target.value);
                                                                    }}
                                                                    invalid={validation.errors.phone_number && validation.touched.phone_number ? true : false}
                                                                    pattern="^\+?[1-9]\d{1,14}$"
                                                                />
                                                                {validation.errors.phone_number && validation.touched.phone_number ? (
                                                                    <FormFeedback type="invalid">{validation.errors.phone_number}</FormFeedback>
                                                                ) : null}
                                                                <DropdownMenu as='ul' className="list-unstyled w-100 dropdown-menu-list mb-0">
                                                                    <div className="p-2 px-3 pt-1 searchlist-input">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control-sm border search-countryList w-100"
                                                                            style={{ height: '40px' }}
                                                                            placeholder="Search country name or code..."
                                                                            value={searchQuery}
                                                                            onChange={(e) => setSearchQuery(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <SimpleBar style={{ maxHeight: "220px" }} className="px-3">
                                                                        {(country || [])
                                                                        .filter(item => 
                                                                            item.countryName.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                                                            item.countryCode.includes(searchQuery))
                                                                            .map((item, key) => (
                                                                            <DropdownItem as='li' onClick={() => setseletedCountry3(item)} key={key} className="dropdown-item d-flex">
                                                                                <div className="flex-shrink-0 me-2">
                                                                                    <img src={item.flagImg} alt="country flag" className="options-flagimg" height="20" />
                                                                                </div>
                                                                                <div className="flex-grow-1">
                                                                                    <div className="d-flex">
                                                                                        <div className="country-name me-1">{item.countryName}</div>
                                                                                        <span className="countrylist-codeno text-muted">{item.countryCode}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </DropdownItem>
                                                                        ))}
                                                                    </SimpleBar>
                                                                </DropdownMenu>
                                                            </Dropdown>

                                                            <div className="dropdown-menu w-100">
                                                                <div className="p-2 px-3 pt-1 searchlist-input">
                                                                    <label type="text" className="form-control-sm border search-countryList" placeholder="Search country name or country code..." />
                                                                </div>
                                                                <ul className="list-unstyled dropdown-menu-list mb-0"></ul>
                                                            </div>
                                                        </div>

                                                        {/* Country and Zip Code on the same row */}
                                                        <div>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label htmlFor="country" className="form-label">Country <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="country"
                                                                            placeholder="Enter Country"
                                                                            name="country"
                                                                            value={validation.values.country}
                                                                            onBlur={validation.handleBlur}
                                                                            onChange={validation.handleChange}
                                                                            invalid={validation.errors.country && validation.touched.country ? true : false}
                                                                        />
                                                                        {validation.errors.country && validation.touched.country ? (
                                                                            <FormFeedback type="invalid">{validation.errors.country}</FormFeedback>
                                                                        ) : null}
                                                                    </div>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <div className="mb-3">
                                                                        <Label htmlFor="zip_code" className="form-label">Zip Code <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="zip_code"
                                                                            placeholder="Enter Zip Code"
                                                                            name="zip_code"
                                                                            value={validation.values.zip_code}
                                                                            onBlur={validation.handleBlur}
                                                                            onChange={validation.handleChange}
                                                                            invalid={validation.errors.zip_code && validation.touched.zip_code ? true : false}
                                                                        />
                                                                        {validation.errors.zip_code && validation.touched.zip_code ? (
                                                                            <FormFeedback type="invalid">{validation.errors.zip_code}</FormFeedback>
                                                                        ) : null}
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                        <div className="mb-3">
                                                            <Label className="form-label" htmlFor="password-input">Password <span className="text-danger">*</span></Label>
                                                            <div className="position-relative auth-pass-inputgroup">
                                                                <Input
                                                                    name="password"
                                                                    value={validation.values.password}
                                                                    type={passwordShow ? "text" : "password"}
                                                                    className="form-control pe-5"
                                                                    placeholder="Enter password"
                                                                    onBlur={validation.handleBlur}
                                                                    onChange={validation.handleChange}
                                                                    invalid={validation.errors.password && validation.touched.password ? true : false}
                                                                />
                                                                {validation.errors.password && validation.touched.password ? (
                                                                    <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                                ) : null}
                                                                <Button
                                                                    color="link"
                                                                    onClick={() => setPasswordShow(!passwordShow)}
                                                                    className="position-absolute end-0 top-0 text-decoration-none text-muted"
                                                                    type="button"
                                                                    id="password-addon"
                                                                >
                                                                    <i className="ri-eye-fill align-middle"></i>
                                                                </Button>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3">
                                                            <Label htmlFor="confirm_password" className="form-label">Confirm Password <span className="text-danger">*</span></Label>
                                                            <Input
                                                                type="password"
                                                                className="form-control"
                                                                id="confirm_password"
                                                                placeholder="Confirm Password"
                                                                name="confirm_password"
                                                                value={validation.values.confirm_password}
                                                                onBlur={validation.handleBlur}
                                                                onChange={validation.handleChange}
                                                                invalid={validation.errors.confirm_password && validation.touched.confirm_password ? true : false}
                                                            />
                                                            {validation.errors.confirm_password && validation.touched.confirm_password ? (
                                                                <FormFeedback type="invalid">{validation.errors.confirm_password}</FormFeedback>
                                                            ) : null}
                                                        </div>

                                                        <div className="mt-4">
                                                            <Button className="btn btn-success w-100" type="submit">
                                                                {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : "Sign Up"}</Button>
                                                        </div>


                                                    </Form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p className="mb-0">Already have an account? <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Signin</Link></p>
                                                </div>

                                                <div className="mt-4 text-center">
                                                   
                                                        <p className="mb-0">
                                                            <a href="https://www.mediapulse.io/terms" className="text-muted text-decoration" rel="noopener noreferrer">Terms of Service</a>  |  
                                                            <a href="https://www.mediapulse.io/privacy-policy" className="text-muted text-decoration" rel="noopener noreferrer"> Privacy Policy</a>
                                                        </p>
                                                   
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                <footer className="footer">
                    <Container>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text-center">
                                    <p className="mb-0">&copy; {new Date().getFullYear()} Whistlemind Technologies LLP. Crafted with <i className="mdi mdi-heart text-danger"></i></p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </footer>
            </div>

        </React.Fragment>
    );
};

export default Register;
